'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.FetchMiddleware = FetchMiddleware;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _effects = require('redux-saga/effects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function* FetchMiddleware(_ref, next) {
    let request = _ref.request,
        response = _ref.response;

    let paramKeys = (0, _keys2.default)(request.params);
    let params = paramKeys.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(request.params[key])).join('&');
    let baseUrl = request.url;
    let url = params ? baseUrl + '?' + params : baseUrl;
    let result = yield safeFetch(url, {
        body: request.body,
        credentials: request.credentials,
        headers: request.headers,
        method: request.method
    });
    response.statusText = result.statusText;
    response.statusCode = result.status;
    response.url = result.url;
    response.headers = headersToObject(result.headers);
    try {
        response.body = yield (0, _effects.call)(() => result.json());
    } catch (ex) {
        response.bodyError = ex;
    }
    yield* next();
}
function* safeFetch(url, options) {
    try {
        return yield (0, _effects.call)(() => (0, _isomorphicFetch2.default)(url, options));
    } catch (ex) {
        return {
            statusCode: 0,
            statusText: 'error'
        };
    }
}
function headersToObject(headers) {
    if (headers.get && headers.keys) {
        let keys = headers.keys();
        let res = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                let key = _step.value;

                res[key] = headers.get(key);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return res;
    }
    return headers;
}
//# sourceMappingURL=FetchMiddleware.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/middlewares/FetchMiddleware.js